export default function phoneDisplay(phone) {
  if (!phone) return "";

  if (phone.length > 10) {
    return phone.replace(/^(\d{2})(\d{5})(\d*)/, "($1) $2 - $3");
  }

  return phone.replace(/^(\d{2})(\d{4})(\d*)/, "($1) $2 - $3");
}
